import { registerValidator } from '@philips-emr/tws-core/lib/services/model-service';

import { BooleanValidator } from './boolean-validator';
import { EmailValidator } from './email-validator';
import { passwordValidator } from './password-validator';

registerValidator('boolean', BooleanValidator);
registerValidator('email', EmailValidator);
passwordValidator();

export * from './password-validator';
export * from './value-validator';
